import { formatCurrency } from "../../../utils/formatCurrency";
import { RecordingStatus, TerminalAttempt } from "./terminalPaymentApi";

const DECLINE_REASON_TEXTS: Record<string, string> = {
    insufficient_funds: "saldo insuficiente",
    suspected_fraud: "suspeita de fraude",
    high_risk: "suspeita de fraude",
    transaction_not_allowed_for_cardholder: "transação não permitida para este cartão",
    transaction_not_allowed: "transação não permitida para este cartão",
    expired_card: "cartão expirado",
    invalid_pin: "PIN incorreto",
    pin_try_exceeded: "PIN bloqueado por excesso de tentativas",
    pin_required: "é necessário introduzir o PIN",
    lost_card: "cartão bloqueado",
    stolen_card: "cartão bloqueado",
    pick_up_card: "cartão bloqueado",
    restricted_card: "cartão bloqueado",
    withdrawal_limit_exceeded: "limite do cartão excedido",
    withdrawal_frequency_exceeded: "limite do cartão excedido",
    rejected_by_customer: "cancelado pelo cliente",
};

const FAILURE_CODE_TEXTS: Record<string, string> = {
    terminal_busy: "O terminal está ocupado com outro pagamento.",
    terminal_unavailable: "O terminal não está disponível. Confirme que está ligado, online e em modo Pay at Counter.",
    revolut_config_error: "Erro na configuração da ligação à Revolut.",
    revolut_rejected: "A Revolut rejeitou o pedido de pagamento.",
    revolut_unavailable: "Não foi possível contactar a Revolut.",
    push_not_confirmed: "O terminal não confirmou a receção do pedido.",
    push_unconfirmed: "Não foi possível confirmar o pedido no terminal. Verifique a app Revolut e contacte o apoio ao cliente antes de cobrar novamente.",
    revolut_not_found: "A Revolut já não encontra este pedido de pagamento.",
};

const DEFAULT_DECLINE_MESSAGE = "Recusado pelo banco do cartão.";
const DEFAULT_FAILURE_MESSAGE = "O pagamento falhou no terminal.";

export const buildPaidMessage = (amount: number, recordingStatus: RecordingStatus | null) => {
    const paidAmount = formatCurrency(amount);
    const messagesByRecordingStatus: Record<RecordingStatus, string> = {
        recorded: `Pagamento aceite: ${paidAmount}. Pagamento registado na compra.`,
        pending: `Pagamento aceite: ${paidAmount}. Ainda não foi registado na compra; não cobre novamente.`,
        needs_review: `Pagamento aceite: ${paidAmount}, mas não foi possível registá-lo automaticamente na compra. Foi criada uma tarefa para verificação; não cobre novamente.`,
    };
    const paidMessage = messagesByRecordingStatus[recordingStatus ?? "pending"];
    return paidMessage;
};

const buildDeclineMessage = (declineReason: string | null) => {
    const reasonText = declineReason ? DECLINE_REASON_TEXTS[declineReason] : undefined;
    const declineMessage = reasonText ? `Recusado: ${reasonText}.` : DEFAULT_DECLINE_MESSAGE;
    return declineMessage;
};

const buildFailureMessage = (failureCode: string | null) => {
    const failureMessage = (failureCode && FAILURE_CODE_TEXTS[failureCode]) || DEFAULT_FAILURE_MESSAGE;
    return failureMessage;
};

export const buildAttemptMessage = (attempt: TerminalAttempt) => {
    const messagesByStatus: Record<TerminalAttempt["status"], () => string> = {
        pending: () => "À espera do cartão do cliente…",
        processing: () => "O cliente está a pagar…",
        paid: () => buildPaidMessage(attempt.amount, attempt.recording_status),
        declined: () => buildDeclineMessage(attempt.failure_reason),
        expired: () => "Tempo esgotado: o cliente não apresentou o cartão.",
        cancelled: () => "Pedido de pagamento cancelado.",
        failed: () => buildFailureMessage(attempt.failure_reason),
    };
    const attemptMessage = messagesByStatus[attempt.status]();
    return attemptMessage;
};
